(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = '1';
      var items = root.querySelectorAll('.sb-ann__item');
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, 3500);
    }
    function initAll() { document.querySelectorAll('[data-sb-ann]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-autumn-leaves"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'sb-leaves-shown';
    var COLORS = ['#B5532A', '#D9A13B', '#7A2E2A', '#6B6B3A', '#C9962E'];
    var SHAPES = [
      'M12 1c1 3 4 3 5 2-.5 2 .5 3 3 3-2 1-2 3-1 4-2 0-3 1-3 3-1-1-3-1-4 0v8h-1v-8c-1-1-3-1-4 0 0-2-1-3-3-3 1-1 1-3-1-4 2.5 0 3.5-1 3-3 1 1 4 1 5-2z',
      'M12 2C6 6 5 13 12 22c7-9 6-16 0-20zm0 3v15',
      'M12 2c-4 3-6 7-4 12 1 2 3 4 4 8 1-4 3-6 4-8 2-5 0-9-4-12z'
    ];
    var NS = 'http://www.w3.org/2000/svg';
    function run(root) {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var inEditor = window.Shopify && window.Shopify.designMode;
      if (root.dataset.once === 'true' && !inEditor) {
        try { if (sessionStorage.getItem(KEY)) return; sessionStorage.setItem(KEY, '1'); } catch (e) {}
      }
      var W = window.innerWidth, H = window.innerHeight;
      var n = parseInt(root.dataset.count, 10) || 10;
      if (W < 750) n = Math.max(4, Math.round(n * 0.8));
      var DUR = parseInt(root.dataset.duration, 10) || 6500;
      var L = [];
      for (var i = 0; i < n; i++) {
        var svg = document.createElementNS(NS, 'svg');
        svg.setAttribute('viewBox', '0 0 24 24');
        var p = document.createElementNS(NS, 'path');
        var c = COLORS[i % COLORS.length];
        p.setAttribute('d', SHAPES[i % SHAPES.length]);
        p.setAttribute('fill', c); p.setAttribute('stroke', c); p.setAttribute('stroke-width', '.6'); p.setAttribute('fill-opacity', '.85');
        svg.appendChild(p);
        var s = (W < 750 ? 18 : 22) + Math.random() * 22;
        svg.style.width = s + 'px'; svg.style.height = s + 'px';
        root.appendChild(svg);
        L.push({ el: svg, x0: Math.random() * W, delay: Math.random() * DUR * 0.45, fall: DUR * (0.5 + Math.random() * 0.35), sway: 30 + Math.random() * 60, spin: (Math.random() - 0.5) * 540, ph: Math.random() * 6.28 });
      }
      var start = performance.now();
      function frame(now) {
        var t = now - start;
        for (var i = 0; i < L.length; i++) {
          var l = L[i], u = (t - l.delay) / l.fall;
          if (u < 0 || u > 1) { l.el.style.opacity = 0; continue; }
          var y = -50 + u * (H + 100), x = l.x0 + Math.sin(u * 6 + l.ph) * l.sway + u * 40, r = l.spin * u + Math.sin(u * 9 + l.ph) * 25;
          l.el.style.opacity = u < 0.08 ? u / 0.08 : (u > 0.85 ? (1 - u) / 0.15 : 1);
          l.el.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + r + 'deg) rotateX(' + (Math.sin(u * 8 + l.ph) * 55) + 'deg)';
        }
        if (t < DUR + 300) requestAnimationFrame(frame); else root.innerHTML = '';
      }
      requestAnimationFrame(frame);
    }
    function initAll() { document.querySelectorAll('[data-sb-lv]').forEach(function (r) { setTimeout(function () { run(r); }, 400); }); }
    if (document.readyState === 'complete') initAll(); else window.addEventListener('load', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-bottom-nav"]) return;
  try {
    
  (function () {
    var nav = document.querySelector('[data-sb-bn2]');
    if (!nav || nav.dataset.sbInit) return;
    nav.dataset.sbInit = '1';
    var m = nav.querySelector('[data-sb-bn2-menu]');
    if (m) m.addEventListener('click', function () {
      if (window.sbOpenMenu) window.sbOpenMenu();
      else { var s = document.querySelector('summary.header__icon--menu'); if (s) s.click(); }
    });
    var sw = document.querySelector('[data-sb-srch]'), sb = nav.querySelector('[data-sb-bn2-search]');
    if (sw && sb) {
      var inp = sw.querySelector('[data-sb-srch-input]'), res = sw.querySelector('[data-sb-srch-res]'), pop = sw.querySelector('[data-sb-srch-pop]'), all = sw.querySelector('[data-sb-srch-all]');
      var timer, ctl, fmt = function (v) { return Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; };
      var esc = function (x) { var d = document.createElement('div'); d.textContent = x == null ? '' : String(x); return d.innerHTML; };
      // Typewriter placeholder: types and erases sample searches until the shopper focuses the field (keyboard only on tap).
      var words = ['İpek twill eşarp', 'Vakko monogram şal', 'Armine nostalji eşarp', 'Pamuk ipek şal', 'Desenli ipek eşarp', 'Düz renk şal'];
      var tw = null, wi = 0, ci = 0, del = false, base = 'Ara: ';
      var tick = function () {
        var w = words[wi % words.length];
        ci += del ? -1 : 1;
        inp.setAttribute('placeholder', base + w.slice(0, ci) + (ci < w.length || del ? '|' : ''));
        var wait = del ? 35 : 75;
        if (!del && ci >= w.length) { del = true; wait = 1400; }
        else if (del && ci <= 0) { del = false; wi++; wait = 350; }
        tw = setTimeout(tick, wait);
      };
      var typeStart = function () { if (tw || inp.value) return; ci = 0; del = false; tw = setTimeout(tick, 450); };
      var typeStop = function (keep) { clearTimeout(tw); tw = null; inp.setAttribute('placeholder', keep ? 'Ne aramıştınız?' : 'Eşarp, şal, marka ara…'); };
      inp.addEventListener('focus', function () { typeStop(true); });
      inp.addEventListener('blur', function () { if (!inp.value && sw.classList.contains('is-open')) typeStart(); });
      var open = function () {
        sw.hidden = false; document.documentElement.classList.add('sb-srch-lock');
        requestAnimationFrame(function () { sw.classList.add('is-open'); });
        typeStart();
      };
      var close = function () {
        sw.classList.remove('is-open'); document.documentElement.classList.remove('sb-srch-lock'); inp.blur(); typeStop();
        setTimeout(function () { sw.hidden = true; }, 380);
      };
      var run = function (q) {
        q = q.trim(); if (ctl) ctl.abort();
        if (q.length < 2) { res.innerHTML = ''; all.hidden = true; pop.hidden = false; return; }
        pop.hidden = true; ctl = window.AbortController ? new AbortController() : null;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide', ctl ? { signal: ctl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!ps.length) { res.innerHTML = '<li class="sb-srch__msg">"' + esc(q) + '" için sonuç bulunamadı.</li>'; all.hidden = true; return; }
            res.innerHTML = ps.map(function (p) {
              var cmp = Number(p.compare_at_price_max) > Number(p.price) ? '<s>' + fmt(p.compare_at_price_max) + '</s>' : '';
              var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '<span class="sb-srch__ph"></span>';
              return '<li><a href="' + esc(p.url) + '">' + img + '<span><span class="sb-srch__t">' + esc(p.title) + '</span><span class="sb-srch__p">' + fmt(p.price) + cmp + '</span></span></a></li>';
            }).join('');
            all.href = '/search?type=product&q=' + encodeURIComponent(q); all.textContent = 'Tüm sonuçları gör'; all.hidden = false;
          }).catch(function () {});
      };
      sb.addEventListener('click', function (e) { e.preventDefault(); open(); });
      sw.querySelectorAll('[data-sb-srch-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sw.hidden) close(); });
      var sheet = sw.querySelector('.sb-srch__sheet'), body = sw.querySelector('.sb-srch__body'), y0 = null, dy = 0;
      sheet.addEventListener('touchstart', function (e) { if (body.contains(e.target) && body.scrollTop > 0) { y0 = null; return; } y0 = e.touches[0].clientY; dy = 0; sheet.style.transition = 'none'; }, { passive: true });
      sheet.addEventListener('touchmove', function (e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); sheet.style.transform = dy ? 'translateY(' + dy + 'px)' : ''; }, { passive: true });
      sheet.addEventListener('touchend', function () { if (y0 === null) return; sheet.style.transition = ''; sheet.style.transform = ''; if (dy > 90) close(); y0 = null; });
      inp.addEventListener('input', function () { clearTimeout(timer); var v = inp.value; timer = setTimeout(function () { run(v); }, 220); });
      sw.querySelectorAll('.sb-srch__chip').forEach(function (c) { c.addEventListener('click', function () { inp.value = c.dataset.q; run(c.dataset.q); }); });
    }
    try {
      var favs = JSON.parse(localStorage.getItem('sb-favs') || '[]');
      var fb = nav.querySelector('[data-sb-bn2-fav]');
      if (fb && favs.length) { fb.textContent = favs.length; fb.hidden = false; }
    } catch (e) {}
    var last = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y > last + 8 && y > 120) nav.classList.add('is-hidden');
        else if (y < last - 8 || y < 120) nav.classList.remove('is-hidden');
        last = y; ticking = false;
      });
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function init(root) {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = '1';
      var end = Date.parse(root.dataset.end || '');
      if (isNaN(end)) { root.hidden = true; return; }
      var el = {};
      ['d', 'h', 'm', 's'].forEach(function (u) { el[u] = root.querySelector('[data-u="' + u + '"]'); });
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { root.hidden = true; clearInterval(timer); return; }
        el.d.textContent = Math.floor(diff / 86400000);
        el.h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        el.m.textContent = pad(Math.floor((diff % 3600000) / 60000));
        el.s.textContent = pad(Math.floor((diff % 60000) / 1000));
      }
      var timer = setInterval(tick, 1000);
      tick();
    }
    function initAll() { document.querySelectorAll('[data-sb-cd]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-favorites"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sb-favs]');
    if (!root) return;
    var grid = root.querySelector('[data-sb-favs-grid]'), empty = root.querySelector('[data-sb-favs-empty]');
    function load() { try { return JSON.parse(localStorage.getItem('sb-favs') || '[]'); } catch (e) { return []; } }
    function save(a) { try { localStorage.setItem('sb-favs', JSON.stringify(a)); } catch (e) {} }
    function money(c) { return (c / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
    function render() {
      var favs = load();
      grid.innerHTML = '';
      empty.hidden = favs.length > 0;
      favs.forEach(function (h) {
        fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          if (!p) { save(load().filter(function (x) { return x !== h; })); return; }
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
          var a = document.createElement('a');
          a.className = 'sb-fav__card'; a.href = p.url;
          a.innerHTML = '<span class="sb-fav__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="sb-fav__t">' + esc(p.title) + '</span>' +
            '<span class="sb-fav__p">' + money(p.price) + (p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '') + '</span>' +
            '<button type="button" class="sb-fav__rm" aria-label="Favorilerden çıkar">♥</button>';
          a.querySelector('.sb-fav__rm').addEventListener('click', function (e) {
            e.preventDefault(); save(load().filter(function (x) { return x !== h; })); a.remove();
            if (!load().length) empty.hidden = false;
          });
          grid.appendChild(a);
        });
      });
    }
    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = '1';
      var slides = root.querySelectorAll('.sb-hero__slide');
      var dots = root.querySelectorAll('.sb-hero__dot');
      if (slides.length < 2) return;
      var current = 0;
      var timer = null;
      var speed = parseInt(root.dataset.speed, 10) || 5000;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function go(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var on = k === current;
          s.classList.toggle('is-active', on);
          if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('tabindex'); }
          else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('tabindex', '-1'); }
        });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === current); });
      }
      function start() {
        if (root.dataset.autoplay !== 'true' || reduced) return;
        stop();
        timer = setInterval(function () { go(current + 1); }, speed);
      }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      root.querySelector('.sb-hero__arrow--prev').addEventListener('click', function () { go(current - 1); start(); });
      root.querySelector('.sb-hero__arrow--next').addEventListener('click', function () { go(current + 1); start(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.index, 10)); start(); }); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);

      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { go(current + (dx < 0 ? 1 : -1)); start(); }
        x0 = null;
      });
      start();
    }
    function initAll() { document.querySelectorAll('.sb-hero').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(form) {
      if (form.dataset.sbInit) return;
      form.dataset.sbInit = '1';
      form.querySelectorAll('[data-sb-col-auto]').forEach(function (el) {
        el.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      });
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type=number]').forEach(function (i) { if (!i.value) i.disabled = true; });
      });
      var tf = form.querySelector('#sb-tf');
      if (tf) {
        var tg = form.querySelector('[data-sb-col-toggle]');
        if (tg) {
          tg.setAttribute('aria-controls', 'sb-tf');
          tg.setAttribute('aria-expanded', tf.hidden ? 'false' : 'true');
          tg.addEventListener('click', function () { tf.hidden = !tf.hidden; tg.setAttribute('aria-expanded', tf.hidden ? 'false' : 'true'); });
        }
        return;
      }
      var panel = form.querySelector('[data-sb-col-panel]');
      var toggle = form.querySelector('[data-sb-col-toggle]');
      var close = form.querySelector('[data-sb-col-close]');
      function set(open) {
        panel.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('sb-noscroll', open);
      }
      if (toggle) toggle.addEventListener('click', function () { set(true); });
      if (close) close.addEventListener('click', function () { set(false); });
    }
    function initAll() { document.querySelectorAll('[data-sb-col-form]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-mobile-menu"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sb-mm]');
    if (!root || root.dataset.sbInit) return;
    root.dataset.sbInit = '1';
    function resetHorizon() {
      document.querySelectorAll('header-drawer details, #Details-menu-drawer-container').forEach(function (d) {
        d.classList.remove('menu-open'); d.removeAttribute('open');
        var sm = d.querySelector('summary'); if (sm) sm.setAttribute('aria-expanded', 'false');
      });
    }
    var panes = {};
    root.querySelectorAll('[data-sb-mm-pane]').forEach(function (p) { panes[p.dataset.sbMmPane] = p; });
    function go(id, back) {
      var cur = root.querySelector('.sb-mm__pane.is-on'), next = panes[id];
      if (!next || next === cur) return;
      if (back) { next.classList.remove('is-left'); next.classList.add('is-on'); cur.classList.remove('is-on'); }
      else { cur.classList.add('is-left'); cur.classList.remove('is-on'); next.classList.add('is-on'); }
      next.scrollTop = 0;
    }
    function reset() {
      Object.keys(panes).forEach(function (k) { panes[k].classList.remove('is-on', 'is-left'); });
      panes.root.classList.add('is-on');
    }
    function open() {
      [0, 60, 400].forEach(function (t) { setTimeout(resetHorizon, t); });
      reset();
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      resetHorizon();
      root.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 350);
    }
    window.sbOpenMenu = open;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('summary.header__icon--menu');
      if (!t || window.matchMedia('(min-width: 990px)').matches) return;
      e.preventDefault(); e.stopPropagation();
      open();
    }, true);
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sb-mm-close]')) return close();
      var g = e.target.closest('[data-sb-mm-go]'); if (g) return go(g.dataset.sbMmGo, false);
      var b = e.target.closest('[data-sb-mm-back]'); if (b) return go(b.dataset.sbMmBack, true);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-product-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(c) { return (c / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
    function init(root) {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = '1';
      var chk = root.querySelector('[data-sb-bn-chk]');
      var tot = root.querySelector('[data-sb-bn-total]');
      var btn = root.querySelector('[data-sb-bn-btn]');
      if (!chk) return;
      chk.addEventListener('change', function () {
        root.querySelectorAll('[data-sb-bn-2]').forEach(function (i) { i.disabled = !chk.checked; });
        tot.textContent = money(parseInt(tot.dataset.base, 10) + (chk.checked ? parseInt(chk.dataset.price, 10) : 0));
        btn.textContent = chk.checked ? 'İkisini birden sepete ekle' : 'Sepete ekle';
      });
    }
    function initAll() { document.querySelectorAll('[data-sb-bn]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = '1';
      var track = root.querySelector('[data-sb-car-track]');
      var btns = root.querySelectorAll('.sb-car__arrow');
      if (!track) return;
      function upd() {
        btns[0].disabled = track.scrollLeft <= 4;
        btns[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: parseInt(b.dataset.dir, 10) * track.clientWidth * 0.8 }); });
      });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
    function initAll() { document.querySelectorAll('[data-sb-car]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function addBizDays(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    function fmt(a, b) {
      if (a.getMonth() === b.getMonth()) return a.getDate() + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
      return a.getDate() + ' ' + MONTHS[a.getMonth()] + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
    }
    function money(cents) { return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
    function init(root) {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = '1';
      var track = root.querySelector('[data-sb-track]');
      var ths = root.querySelectorAll('[data-sb-th]');
      var dots = root.querySelectorAll('.sb-pm__dots i');
      var cur = root.querySelector('[data-sb-cur]');
      var idx = 0;
      function mark(i) {
        idx = i;
        ths.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
        if (cur) cur.textContent = i + 1;
      }
      if (track) {
        track.addEventListener('scroll', function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, { passive: true });
        ths.forEach(function (t) {
          t.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * parseInt(t.dataset.sbTh, 10) }); });
        });
      }
      // lightbox
      var full = [];
      try { full = JSON.parse(root.querySelector('[data-sb-full]').textContent); } catch (e) {}
      var lb = root.querySelector('[data-sb-lb]');
      var lbImg = root.querySelector('[data-sb-lb-img]');
      var zoom = root.querySelector('[data-sb-zoom]');
      if (zoom && lb && lb.showModal) {
        zoom.addEventListener('click', function () { if (full[idx]) { lbImg.src = full[idx]; lb.showModal(); } });
        lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-sb-lb-close]')) lb.close(); });
      }
      // quantity
      var qty = root.querySelector('.sb-pm__qty input');
      root.querySelectorAll('[data-sb-qty]').forEach(function (b) {
        b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.sbQty, 10)); });
      });
      // ship dates
      var eta = root.querySelector('[data-sb-eta]');
      if (eta) { var n = new Date(); eta.textContent = fmt(addBizDays(n, parseInt(eta.dataset.min, 10)), addBizDays(n, parseInt(eta.dataset.max, 10))); }
      // mobile sticky add-to-cart: visible once the main add button scrolls out of view
      var sticky = root.querySelector('[data-sb-sticky]');
      var add = root.querySelector('[data-sb-add]');
      if (sticky && add && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var off = !en[0].isIntersecting;
          sticky.classList.toggle('is-on', off);
          sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
        }).observe(add);
        root.querySelector('[data-sb-sticky-add]').addEventListener('click', function () { add.click(); });
      }
      // variant options
      var vjson = root.querySelector('[data-sb-variants]');
      if (vjson) {
        var variants = JSON.parse(vjson.textContent);
        var idInput = root.querySelector('[data-sb-variant-id]');
        var now2 = root.querySelector('[data-sb-now]');
        var priceNow = root.querySelector('[data-sb-price-now]');
        var priceWas = root.querySelector('[data-sb-price-was]');
        root.querySelectorAll('[data-sb-opt]').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var sel = [];
            root.querySelectorAll('[data-sb-opt]:checked').forEach(function (c) { sel[+c.dataset.sbOpt] = c.value; });
            var lbl = root.querySelector('[data-sb-opt-label="' + inp.dataset.sbOpt + '"]');
            if (lbl) lbl.textContent = inp.value;
            var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); });
            if (!v) return;
            idInput.value = v.id;
            priceNow.textContent = money(v.price);
            var inst = root.querySelector('[data-sb-inst]'), instN = root.querySelector('[data-sb-inst-n]');
            if (inst && instN) inst.textContent = money(Math.floor(v.price / parseInt(instN.dataset.sbInstN, 10)));
            if (priceWas) priceWas.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
            add.disabled = !v.available;
            add.textContent = v.available ? 'Sepete ekle' : 'Tükendi';
            if (now2) now2.hidden = !v.available;
            var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
          });
        });
      }
    }
    function initAll() { document.querySelectorAll('[data-sb-pm]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-product-quotes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sb-qt-more]');
    if (!b) return;
    var row = b.parentNode.querySelector('.sb-qt__row');
    if (row) row.classList.add('is-all');
    b.remove();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-product-similar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function load(el) {
      if (el.dataset.sbInit || el.querySelector('.sbd-in')) return;
      el.dataset.sbInit = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-sb-sim]');
        if (fresh && fresh.querySelector('.sbd-in')) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    }
    function initAll() { document.querySelectorAll('[data-sb-sim]').forEach(load); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.sb-tabs__tab'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.sb-tabs__panel'));
      function show(i) {
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            show(n); tabs[n].focus();
          }
        });
      });
    }
    function initAll() { document.querySelectorAll('[data-sb-tabs]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-product-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = '1';
      var v = root.querySelector('[data-sb-pv-video]');
      var tg = root.querySelector('[data-sb-pv-toggle]'), snd = root.querySelector('[data-sb-pv-sound]'), pl = root.querySelector('[data-sb-pv-play]');
      var user = false;
      function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); root.classList.remove('is-paused'); tg.textContent = 'Durdur'; }
      function stop() { v.pause(); root.classList.add('is-paused'); tg.textContent = 'Oynat'; }
      tg.addEventListener('click', function () { if (v.paused) { user = false; play(); } else { user = true; stop(); } });
      pl.addEventListener('click', function () { user = false; play(); });
      snd.addEventListener('click', function () { v.muted = !v.muted; snd.textContent = v.muted ? 'Sesi aç' : 'Sesi kapat'; if (!v.muted && v.paused) play(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { if (!user) play(); } else { v.pause(); } }); }, { threshold: 0.4 }).observe(v);
      } else play();
    }
    function initAll() { document.querySelectorAll('[data-sb-pv]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.sbInit) return;
      root.dataset.sbInit = '1';
      var track = root.querySelector('.sb-rev__track');
      var prev = root.querySelector('.sb-rev__arrow--prev');
      var next = root.querySelector('.sb-rev__arrow--next');
      if (!track) return;
      function step() { return track.clientWidth; }
      function update() {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll() { document.querySelectorAll('[data-sb-rev]').forEach(init); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
